<h4 mat-dialog-title><div class="display-flex-row"><div class="warning"><mat-icon>warning</mat-icon></div><div><span>User Not Configured</span></div></div></h4>
<mat-dialog-content>
  <p>Application security has not been configured for this user. Please contact <a href="mailto: acceleratorsupport@hyperiongrp.com ">acceleratorsupport@hyperiongrp.com</a></p>
  <p style="font-size: 12px;">Clicking OK will take you back to the log in screen</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button cdkFocusInitial [mat-dialog-close]="true" class="ok-btn">OK</button>
</mat-dialog-actions>